export default __webpack_public_path__ + "static/media/3-logo.c58085f2.svg";